import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { surfaceFromHost, destinoExpulsion } from '../surface';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const getRole = () => {
    try {
      const token = localStorage.getItem('token') || '';
      const b64 = token.split('.')[1] || '';
      const b64fixed = b64.replace(/-/g,'+').replace(/_/g,'/');
      const payload = JSON.parse(atob(b64fixed + '=='));
      return payload.role || '';
    } catch {
      return '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError('Usuario o contrasena incorrectos');
      setLoading(false);
      return;
    }
    setLoading(false);
    const role = getRole();
    const surface = surfaceFromHost(typeof window !== 'undefined' ? window.location.hostname : '');
    const destinoDedicado = destinoExpulsion(surface, role);
    if (destinoDedicado) {
      // En el panel, un rol dedicado (sac/contratos) se va a su dominio.
      localStorage.removeItem('token');
      window.location.href = destinoDedicado;
      return;
    }
    if (role === 'revendedor') {
      navigate('/reseller-dashboard');
    } else {
      navigate('/');
    }
  };

  const EyeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  const EyeOffIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <img src="/eneural-logo.svg" alt="Eneural" width={56} height={56} style={styles.logo} />
          <h1 style={styles.title}>Eneural</h1>
        </div>
        <p style={styles.subtitle}>Carrier Platform · Panel de Administracion</p>
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Usuario</label>
            <input style={styles.input} type="text" value={username}
              onChange={(e) => setUsername(e.target.value)}
              required autoFocus autoComplete="username" />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Contrasena</label>
            <div style={{position:'relative'}}>
              <input
                style={{...styles.input, paddingRight:44}}
                type={showPwd ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPwd(!showPwd)}
                style={{
                  position:'absolute', right:12, top:'50%',
                  transform:'translateY(-50%)',
                  background:'none', border:'none',
                  cursor:'pointer', padding:0,
                  display:'flex', alignItems:'center',
                }}>
                {showPwd ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0f172a' },
  card: { background:'#1e293b', borderRadius:12, padding:'40px 36px', width:340, boxShadow:'0 8px 32px rgba(0,0,0,0.4)' },
  brand: { display:'flex', alignItems:'center', gap:12 },
  logo: { display:'block' },
  title: { color:'#f1f5f9', margin:0, fontSize:30, fontWeight:700, letterSpacing:0.5 },
  subtitle: { color:'#94a3b8', margin:'8px 0 28px', fontSize:13 },
  field: { marginBottom:18 },
  label: { display:'block', color:'#94a3b8', fontSize:13, marginBottom:6 },
  input: { width:'100%', padding:'10px 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:6, color:'#f1f5f9', fontSize:15, boxSizing:'border-box', outline:'none' },
  error: { color:'#f87171', fontSize:13, margin:'0 0 14px' },
  button: { width:'100%', padding:'11px', background:'#0ea5e9', color:'#fff', border:'none', borderRadius:6, fontSize:15, fontWeight:600, cursor:'pointer', marginTop:4 },
};
